import * as Yup from 'yup';
import PropTypes from 'prop-types';

// FILE
export const FilePropTypes = {
    fileType: PropTypes.string,
    remark: PropTypes.string,
    file: PropTypes.any,
};

export const FileDefaultProps = {
    fileType: '',   
    remark: '',
    file: '',
};

export const FileYupSchema = Yup.object().shape({
    companyId: Yup.string().required('Required'),
    productCategory: Yup.string().required('Required'),
    productId: Yup.string().required('Required'),
    catalogueId: Yup.string().nullable(),
    amount: Yup.number().required('Required'),
});

export default {
    FilePropTypes,
    FileYupSchema,
    FileDefaultProps,
};
